import Modal from '../../Common/Modal';
import { useCallback, useEffect, useState } from 'react';
import Payment from '../Payment/Payment';
import { useSelector } from 'react-redux';
import useToggle from '../../../hooks/useToggle';
import { RootState } from '../../../states/reducers';
import PaymentSummary from '../Payment/PaymentSummary';
import { closePaymentModal } from 'flutterwave-react-v3';
import { PaymentType } from '../../../helpers/constants';
import LoadingIndicator from '../../Common/LoadingIndicator';
import ErrorNotification from '../../Common/ErrorNotification';
import SuccessNotification from '../../Common/SuccessNotification';
import { useRepayLoan } from '../../../hooks/payment/useRepayLoan';
import { useFlutterwavePayment } from '../../../hooks/payment/useFlutterwave';

let repaymentAmount = 0;
export const RepayLoan = () => {
  const [repaymentCount, setRepaymentCount] = useState(1);
  const { show: showForm, toggle: toggleForm } = useToggle();
  const { loan } = useSelector((state: RootState) => state.loan);
  const { loanRepayments } = useSelector((state: RootState) => state.loanRepayment);
  const { handleFlutterPayment } = useFlutterwavePayment(repaymentAmount * repaymentCount, 'Loan Repayment', 'Loan Repayment');
  const { processing, error, success, handleCardRepayment, handleVerifyRepayment, handleWalletRepayment, resetState } = useRepayLoan();

  useEffect(() => {
    if (loanRepayments.length >= 1 && repaymentAmount === 0) {
      repaymentAmount = +loanRepayments[0].amount;
    }
  }, [loanRepayments]);

  const onNewCardHandler = () => {
    handleFlutterPayment({
      callback: (response) => {
        closePaymentModal();
        handleVerifyRepayment({
          loan_id: loan!.id,
          transaction_id: response.transaction_id,
          repayments: repaymentCount,
        });
      },
      onClose: () => {},
    });
  };

  const onSavedCardHandler = (cardId: number) => {
    handleCardRepayment({
      loan_id: loan!.id,
      card_id: cardId,
      repayments: repaymentCount,
    });
  };

  const onWalletHandler = () => {
    handleWalletRepayment({ loan_id: loan!.id, repayments: repaymentCount });
  };

  const onCloseModal = useCallback(() => {
    toggleForm();
    resetState();
    setRepaymentCount(1);
  }, [resetState, toggleForm]);

  return (
    <>
      <button className='btn btn-sm btn-primary me-3 my-5' onClick={onCloseModal}>
        Repay Loan
      </button>

      <Modal show={showForm} toggle={onCloseModal} backDropClose={false} title='Repay Loan'>
        {processing ? (
          <div className='text-center'>
            <LoadingIndicator />
          </div>
        ) : error ? (
          <ErrorNotification message={error} />
        ) : success ? (
          <SuccessNotification message='Your loan has been repaid' />
        ) : (
          <>
            <PaymentSummary amount={repaymentAmount} repaymentCount={repaymentCount} type={PaymentType.REPAYMENT} />

            <div className='row mt-4'>
              <label className='col-lg-9 form-label fs-7'>No of Repayments</label>

              <div className='col-lg-3 fv-row text-end fs-4 text-primary fw-bolder'>
                <input type='number' max={loanRepayments.filter((repayment) => !repayment.paid).length} min={1} value={repaymentCount} onChange={(e) => setRepaymentCount(+e.target.value)} className='form-control form-control-sm form-control-solid' />
              </div>
            </div>

            <Payment newCardHandler={onNewCardHandler} savedCardHandler={onSavedCardHandler} walletHandler={onWalletHandler} type={PaymentType.REPAYMENT} />
          </>
        )}
      </Modal>
    </>
  );
};
